import { createSlice } from '@reduxjs/toolkit';

// Function to load discount from localStorage
const loadDiscountFromLocalStorage = () => {
  const savedDiscount = localStorage.getItem('discount');
  return savedDiscount ? JSON.parse(savedDiscount) : null; // Parse and return saved discount
};

// Function to save discount to localStorage
const saveDiscountToLocalStorage = (discount) => {
  localStorage.setItem('discount', JSON.stringify(discount)); // Save as stringified JSON
};

// Initial state now loads the discount from localStorage
const promoSlice = createSlice({
  name: 'promo',
  initialState: {
    discount: loadDiscountFromLocalStorage(), // Load from localStorage
  },
  reducers: {
    applyDiscount: (state, action) => {
      state.discount = action.payload;
      saveDiscountToLocalStorage(state.discount); // Save to localStorage when discount is applied
      console.log("🚀 ~ state.discount:", state.discount);
    },
    clearDiscount: (state) => {
      state.discount = null;
      localStorage.removeItem('discount'); // Remove from localStorage when discount is cleared
    },
  },
});

export const { applyDiscount, clearDiscount } = promoSlice.actions;

export default promoSlice.reducer;
